import React from 'react';
import {DeprecatedText as Text} from '@forecast-it/design-system';
import {
	getNotAllowedReasonEntityLabel,
	TimeRegistrationNotAllowedReason,
} from '../../util/time-registration/time-registration-settings/TimeRegistrationNotAllowedReason';
import styled from 'styled-components';

const TimeRegistrationNotAllowedTooltip = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export function getTimeRegistrationNotAllowedTooltip(notAllowedReason: TimeRegistrationNotAllowedReason): JSX.Element {
	const notAllowedReasonEntityLabel = getNotAllowedReasonEntityLabel(notAllowedReason);
	return (
		<TimeRegistrationNotAllowedTooltip>
			<Text>{`Your company does not allow registering time ${notAllowedReasonEntityLabel}.`}</Text>
			<Text type={'small'} color={'secondary'}>
				Contact your admin for more information.
			</Text>
		</TimeRegistrationNotAllowedTooltip>
	);
}
